window.$ = jQuery;
import swiper from 'swiper';
import Responsive from './Responsive';

const r = new Responsive();
const template = require('./_template.html');
const infiniteSlide = require('./infiniteSlide.js');

const chunk = function chunk (array, size) {
  return array.reduce(function (res, item, index) {
    if (index % size === 0) { res.push([]); }
    res[res.length-1].push(item);
    return res;
  }, []);
}

module.exports = function() {
	let is = {};
	let iss = {};


	(function($) {
	$(function(){
		$(window).on('load resize',function(){
			let addwidth = 0;
			if($(this).width() > 1000){
				addwidth = ($(this).width() - 1000) / 2;
			}

			$('.instagram_header-wrapper').css({'left':addwidth});
		});

		const Request = {
			send:function(obj){
				let defer = $.Deferred();
				$.ajax({
					type: 'POST',
					url: GLOBAL_INSTAGRAM_REQUEST,
					dataType: 'json',
					context:obj,
					success: defer.resolve,
					error: defer.reject
				});
				return defer.promise();
			}
		};
		Request.send($(this)).then(
			function(data){

				let chunked = chunk(data.data, 10);

				let compiled = _.template(template);
				let compiled_data_t = _.map(chunked[0], function(d) {
					return compiled(d);
				});

				let compiled_data_b = _.map(chunked[1], function(d) {
					return compiled(d);
				});

				$('.js-autoslide-t ul').append(compiled_data_t);
				$('.js-autoslide-b ul').append(compiled_data_b);
				$('.instagram_header-imgarea').css({'background-image':'url('+chunked[0][0].images.standard_resolution.url+')'});
			},
			function(data){
				console.log('request failed：' + data);
			}
		).then(
			function(){
				is = $('.js-autoslide-t').infiniteslide({
					'speed': 70,
					'pauseonhover': false
				});

				iss = $('.js-autoslide-b').infiniteslide({
					'direction':'right',
					'speed': 70,
					'pauseonhover': false
				});
			}
		);
	});
	})(jQuery);
}



// WEBPACK FOOTER //
// ./dev/js/scripts/instagram.js